import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AboutUs from "./sections/AboutUs";
import OurServices from "./sections/OurServices";
import OurPartners from "./sections/OurPartners";
import FAQ from "./sections/FAQ";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <AboutUs />
      <OurServices />
      <OurPartners />
      <FAQ />
      <Contact />
      <Footer />
    </div>;
}